// extracted by mini-css-extract-plugin
export default {"dropZoneBlock":"DropZoneFile_dropZoneBlock__NjeEr","dropDownTitle":"DropZoneFile_dropDownTitle__WkdEF"};